import { WebphoneCallEvent } from '../types';
import IWebPhoneService from '../IWebPhoneService';
import appManager from '@app/appManager';
import IAppLogger from '@app/lib/IAppLogger';
import ToastModule from '@modules/ToastModule';
import strings from '../constants/strings';
import toastDurations from '@lib/utils/toastDurations';
import { CallFailurePhrases } from '../constants/callFailurePhrases';

// Used to handle the outbound call fails due to user unavailable and not have voicemail setup
const handleCallFailed = (
  webPhoneService: IWebPhoneService,
  newCallEvent: WebphoneCallEvent,
  logger: IAppLogger,
) => {
  logger.info(
    `Handling softphone call failed: ${newCallEvent.callId}`,
    newCallEvent,
    webPhoneService,
  );

  // Always emit phone.call.failed-general so any module can observe all
  // telephony-level failures without being limited to the endpointNotAvailable
  // subset that phone.call.failed covers.
  appManager.events.emit('phone.call.failed-general', newCallEvent);

  // this phrase is used to identify the call failed due to user not available and not having voicemail setup
  if (
    newCallEvent.reasonPhrase.toLowerCase() ===
    CallFailurePhrases.endpointNotAvailable
  ) {
    ToastModule.showToast({
      title: strings.toasts.callFailedOutboundTitle,
      status: 'info',
      duration: toastDurations.callMissedToastDuration,
    });

    appManager.events.emit('phone.call.failed', newCallEvent);
    return;
  }
};

export default handleCallFailed;
